<div *ngIf="isAdminObservable | async as isAdmin" class="card">

    <div class="card-body">
        <h5 class="card-title">Azure function app management</h5>
        <div *ngIf="dataObservable | async as data; else loading">
            <dx-data-grid [dataSource]="data" [allowColumnResizing]="true" [allowColumnReordering]="true" [wordWrapEnabled]="true">
                <dxo-selection
                [showCheckBoxesMode]="'none'"
              ></dxo-selection>
                <dxo-filter-row
                [visible]="true"
              ></dxo-filter-row>
                <dxi-column cellTemplate="cellTemplate" [width]=220></dxi-column>

                <dxi-column dataField="linkId"></dxi-column>
                <dxi-column dataField="instanceId"></dxi-column>
                <dxi-column dataField="runtimeStatus"></dxi-column>
                <dxi-column dataField="customStatus"></dxi-column>
                <dxi-column dataField="output"></dxi-column>
                <dxi-column dataField="createdTime" dataType="datetime"></dxi-column>
                <dxi-column dataField="lastUpdatedTime" dataType="datetime"></dxi-column>



                <div *dxTemplate="let data of 'cellTemplate'">
                    <ng-container *ngIf="data.data.runtimeStatus == 'Running'">
                        <button style="margin:5px;" (click)="killInstance(data.data)"
                            class="btn btn-primary btn-sm">Kill instance</button>
                    </ng-container>
                    <!-- <ng-container *ngIf="data.data.runtimeStatus != 'Running'"> -->
                    <button (click)="purgeHistory(data.data)" class="btn btn-primary btn-sm">Purge history</button>
                    <!-- </ng-container> -->
                </div>
            </dx-data-grid>
        </div>
        <ng-template #loading>Loading....</ng-template>
    </div>
</div>

